"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _variables = require("./common/variables");

var _HalstackContext = require("./HalstackContext");

var useTranslatedLabels = function useTranslatedLabels() {
  var labels = (0, _react.useContext)(_HalstackContext.HalstackLanguageContext);
  return labels || _variables.defaultTranslatedComponentLabels;
};

var _default = useTranslatedLabels;
exports["default"] = _default;